import { Button, Col, Modal, Row } from 'react-bootstrap';
import React, { useState } from 'react';
import Blockquote from '../../../components/Blockquote';
import { RadioGroup } from '../../../components/Radio';
import CardWithCheckbox from '../../../components/CardWithCheckbox/CardWithCheckbox';
import useMobile from '../../../hooks/useMobileHook';
import {
  formatAddressInTwoLines,
  getAllAddressesMappedByType,
} from '../../../services/addresses';

export type ReceiveFormsMailModalProps = React.PropsWithChildren<{
  showModal: boolean;
  closeModal: () => void;
  data?: any;
}>;

const ReceiveFormsMailModal = ({
  showModal,
  closeModal,
  data,
}: ReceiveFormsMailModalProps) => {
  const val = '';
  const [value, setValue] = useState<string | number>(val);
  const isMobile = useMobile();
  const addresses = getAllAddressesMappedByType();

  const handleChange = (e: string | number) => {
    setValue(e);
  };

  const [workAddress1, workAddress2] = formatAddressInTwoLines(
    addresses.work[0]
  );
  const [altAddress1, altAddress2] = formatAddressInTwoLines(addresses.alt[0]);
  const [homeAddress1, homeAddress2] = formatAddressInTwoLines(
    addresses.home[0]
  );

  const cardsData = [
    {
      mailLocation: 'Work',
      address: workAddress1,
      city: workAddress2,
      id: 'Work',
    },

    {
      mailLocation: 'Alternate',
      address: altAddress1,
      city: altAddress2,
      id: 'Alternate',
    },

    {
      mailLocation: 'Home',
      address: homeAddress1,
      city: homeAddress2,
      id: 'Home',
    },
  ];

  return (
    <Modal
      fullscreen={isMobile}
      size={'xl'}
      show={showModal}
      onHide={closeModal}
    >
      <Modal.Header className={'no-border pb-0'} closeButton>
        <Row>
          <Col className={'col-12'}>
            <h2 className={'text-sm-20-lg-32 fw-light'}>
              Receive Forms via Mail
            </h2>
          </Col>
        </Row>
      </Modal.Header>
      <Modal.Body className={'px-7 pb-0 p-lg-12 pb-lg-0'}>
        <Row>
          <Col>
            <Blockquote>
              <Row>
                <Col className={'col-12'}>
                  <span className={'fw-bold text-fs-6 text-light-grey'}>
                    Where should we mail the form?
                  </span>
                </Col>
                <Col className={'col-12'}>
                  <span className={'text-fs-6 fw-light'}>
                    Mail Beneficiary Designation Authorization Form to any of
                    these addresses
                  </span>
                </Col>
              </Row>
            </Blockquote>
          </Col>
        </Row>
        <Row className={'flex-column flex-lg-row mt-10 mt-lg-12'}>
          <RadioGroup name={'mail-form'} onChange={handleChange} value={value}>
            {cardsData.map((cardData) => {
              return (
                <Col className={'mb-10 mb-lg-0'}>
                  <CardWithCheckbox
                    selected={value === cardData.id}
                    cardData={cardData}
                  />
                </Col>
              );
            })}
          </RadioGroup>
        </Row>
      </Modal.Body>
      <Modal.Footer className={'pt-3 pt-lg-10'}>
        <Button onClick={closeModal} variant={'primary-outline'}>
          Cancel
        </Button>
        <Button onClick={closeModal} className={'mb-7 mb-lg-0'}>
          Send
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReceiveFormsMailModal;
